import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getTopMenus } from '../../../../redux/menus/selectors';

const PVMenuLeft = (props) => {
    const { topMenus, leftMenuName } = props;
    const [currentMenuId, setCurrentMenuId] = React.useState(null);
    // Use a ref instead of state for tracking the last clicked URL
    const lastClickedUrlRef = useRef(null);
    // Track the last click timestamp to prevent double-clicks
    const lastClickTimeRef = useRef(0);

    function moveCanvasWithoutAnimation(wholeMenu, callback) {
        wholeMenu.classList.remove('pv-nav-animate');
        callback();
    }

    function moveCanvasWithAnimation(wholeMenu, callback) {
        wholeMenu.classList.add('pv-nav-animate');
        callback();
    }

    function moveCanvas(navToMenu) {
        let navToMenu2 = navToMenu;
        if (navToMenu2 === null) {
            navToMenu2 = document.getElementById('LeftMenuShop');
            if (navToMenu2 === null) {
                navToMenu2 = document.getElementById('LeftMenuProducts');
            }
        }
        const navToMenuVerticalOrder = navToMenu2.dataset.order;
        const navToMenuLevel = navToMenu2.parentNode.parentNode;
        const newLevelTop = `${(navToMenuVerticalOrder - 1) * -1200}px`;
        navToMenuLevel.style.top = newLevelTop;

        const navToMenuHorizontalOrder = navToMenuLevel.dataset.order;
        const canvas = document.getElementById('pv-nav-canvas-left');
        const newCanvasLeft = `${(navToMenuHorizontalOrder - 1) * -350}px`;
        canvas.style.left = newCanvasLeft;
    }

    useEffect(() => {
        if (leftMenuName !== '') {
            const navToHref = `#LeftMenu${props.leftMenuName.replace('&', '')}`;
            const navToID = navToHref.substr(1);
            const navToMenu = document.getElementById(navToID);
            moveCanvas(navToMenu);
        }
    }, [leftMenuName]);

    function handleClick(e) {
        //console.log("Click event:", e.currentTarget.tagName, e.currentTarget.getAttribute('href'), e.currentTarget.getAttribute('to'));

        // Get current time to check for double clicks
        const now = Date.now();
        const url = e.currentTarget.getAttribute('href');

        // Prevent rapid clicks on the same element (within 500ms)
        if (url === lastClickedUrlRef.current && now - lastClickTimeRef.current < 500) {
            //console.log("Preventing rapid second click");
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        // Update refs with current click info
        lastClickedUrlRef.current = url;
        lastClickTimeRef.current = now;

        if (url === null) {
            return;
        }

        // Check if this is a menu navigation or a regular link
        const isMenuNavigation = url.substr(0, 1) === '#';

        // For regular links (non-menu navigation)
        if (!isMenuNavigation) {
            //console.log("Regular link clicked:", url);
            // Let navigation continue normally
            return;
        }

        // For menu navigation
        //console.log("Menu navigation link clicked:", url);
        e.preventDefault(); // Prevent default early to ensure no navigation happens

        const navToID = url.substr(1);

        // Special case for 'Close'
        if (navToID === 'Close') {
            const wholeMenu = document.getElementById('pv-nav-menu-left');
            wholeMenu.style.display = 'none';
            return;
        }

        // If it's the same menu item clicked again, don't do anything
        if (navToID === currentMenuId) {
            //console.log(`Same menu clicked again: ${navToID}`);
            return;
        }

        // Store which menu was clicked for future reference
        setCurrentMenuId(navToID);

        const wholeMenu = document.getElementById('pv-nav-menu-left');
        wholeMenu.style.display = 'block';

        const navToMenu = document.getElementById(navToID);
        if (!navToMenu) {
            //console.error(`Menu element not found: ${navToID}`);
            return;
        }

        // Get the menu level and type
        const menuType = e.currentTarget.dataset.menu || 'sub'; // Default to 'sub' if not specified

        // Reset scroll position
        navToMenu.scrollTop = 0;

        // Apply appropriate classes to control menu appearance
        if (menuType === 'main') {
            wholeMenu.classList.remove('is-sub-menu');
            wholeMenu.classList.add('is-main-menu');
        } else if (menuType === 'sub') {
            wholeMenu.classList.remove('is-main-menu');
            wholeMenu.classList.add('is-sub-menu');
        }

        // Determine if animation should be used
        // Shop All should never animate when clicked
        const isShopAllCategory = navToID.includes('ShopAll') || navToID.includes('LeftMenuShopAll');
        const isAnimationDesired = !isShopAllCategory && menuType !== 'main' && menuType !== 'sub';

        // Move the canvas to show the selected menu
        if (isAnimationDesired) {
            moveCanvasWithAnimation(wholeMenu, function move() {
                moveCanvas(navToMenu);
            });
        } else {
            moveCanvasWithoutAnimation(wholeMenu, function move() {
                moveCanvas(navToMenu);
            });
        }
    }

    const renderPvMenuItem = (items) => {
        return (
            <div>
                {items.map((item) => {
                    let iconClass = '';

                    if (item.itemClass === 'pv-nav-forward') {
                        iconClass = 'pv-nav-icon-angle-right';
                    } else if (
                        item.itemClass === 'pv-nav-back' ||
                        item.itemClass === 'pv-nav-back-main-only'
                    ) {
                        iconClass = 'pv-nav-icon-angle-left';
                    }

                    if (item.itemPageType === 'React' && item.itemClass === 'pv-nav-item-link') {
                        // Special handling for "Shop All" item to prevent navigation issues
                        if (item.itemName.includes("Shop All")) {
                            return (
                                <li key={item.itemID}>
                                <a
                                    href={item.itemHref}
                                    className={`${item.itemClass} ${iconClass}`}
                                    draggable="false"
                                    onClick={handleClick}
                                    data-menu="sub"
                                    data-item-id={item.itemID}
                                    >
                                    {item.itemName}
                                </a>
                                </li>
        );
    }

    // Standard React Router Link for other items
    return (
        <li key={item.itemID}>
            <Link
                to={item.itemHref}
                className={`${item.itemClass} ${iconClass}`}
                draggable="false"
                onClick={handleClick}
                data-menu="sub"
            >
                {item.itemName}
            </Link>
        </li>
    );
}

return (
    <li key={item.itemID}>
    <a
        href={
            item.itemHref != null
                ? item.itemHref.replace('#Menu', '#LeftMenu')
                : item.itemHref
        }
        className={`${item.itemClass} ${iconClass}`}
        draggable="false"
        onClick={handleClick}
        data-menu={item.itemClass === 'pv-nav-back' || item.itemClass === 'pv-nav-back-main-only' ? 'main' : 'sub'}
        data-item-id={item.itemID}
                            >
        {item.itemName}
    </a>
                        </li >
                    );
                })}
            </div >
        );
    };

const renderPvMenu = (menus) => {
    return (
        <div>
            {menus.map((menu) => {
                return (
                    <div
                        key={menu.menuID.replace('Menu', 'LeftMenu').replace('&', '')}
                        id={menu.menuID.replace('Menu', 'LeftMenu').replace('&', '')}
                        data-order={menu.menuOrder}
                        data-menu-name={menu.menuName}
                        className={`pv-nav-menu ${menu.menuClass}`}
                        draggable="false"
                    >
                        <ul>{renderPvMenuItem(menu.menuItems)}</ul>
                    </div>
                );
            })}
        </div>
    );
};

const renderPvNavMenuLevel = (levels) => {
    return (
        <div id="pv-nav-canvas-left">
            {levels.map((level) => {
                return (
                    <div key={level.levelID} id={level.levelID} data-order={level.levelOrder}>
                        {renderPvMenu(level.levelMenus)}
                    </div>
                );
            })}
        </div>
    );
};

return (
    <div id="pv-nav">
        <div id="stickyMenu">
            <div id="pv-nav-menu-left">
                <div id="pv-nav-window">{renderPvNavMenuLevel(topMenus)}</div>
            </div>
        </div>
    </div>
);
};

PVMenuLeft.propTypes = {
    topMenus: PropTypes.oneOfType([PropTypes.any]).isRequired,
    leftMenuName: PropTypes.string,
};

PVMenuLeft.defaultProps = {
    leftMenuName: 'Shop',
};

const mapStateToProps = (state) => {
    return { topMenus: getTopMenus(state) };
};

export default connect(mapStateToProps, null)(PVMenuLeft);